import { useEffect } from "react";
import Lenis from "lenis";

export default function SmoothScroll({ children }) {
    useEffect(() => {
        const lenis = new Lenis({
            // Snappy — short duration with cubic ease-out reads as
            // "responsive momentum" instead of "drifting smooth scroll".
            duration: 0.8,
            easing: (t) => 1 - Math.pow(1 - t, 3), // easeOutCubic
            smoothWheel: true,
            wheelMultiplier: 1.0,
        });
        // Expose so route-change scroll-to-top can reset the lenis state.
        window.__lenis = lenis;
        let rafId;
        function raf(time) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            delete window.__lenis;
            lenis.destroy();
        };
    }, []);
    return children;
}
